(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["authentic-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activateReviews = (root) => {
      root.querySelectorAll('[data-authentic-reviews]').forEach((section) => {
        if (section.dataset.reviewsReady === 'true') return;
        section.dataset.reviewsReady = 'true';
        const buttons = [...section.querySelectorAll('[data-review-filter]')];
        const cards = [...section.querySelectorAll('[data-review-rating]')];
        const status = section.querySelector('[data-review-status]');
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const filter = button.dataset.reviewFilter;
            let visible = 0;
            buttons.forEach((item) => {
              const active = item === button;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            cards.forEach((card) => {
              const show = filter === 'all' || card.dataset.reviewRating === filter;
              card.hidden = !show;
              if (show) visible += 1;
            });
            if (status) {
              status.textContent = status.dataset.template
                ? status.dataset.template.replace('[visible]', visible).replace('[total]', cards.length)
                : `${visible} / ${cards.length}`;
            }
          });
        });
      });
    };

    activateReviews(document);
    document.addEventListener('shopify:section:load', (event) => activateReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-storefront-refinements"]) return;
  try {
    
  (() => {
    const activateHomepageDepth = () => {
      const page = document.body;
      if (page.dataset.homeDepthReady === 'true') return;
      page.dataset.homeDepthReady = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let frame = 0;
      const update = () => {
        frame = 0;
        const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        const progress = Math.min(1, Math.max(0, window.scrollY / maxScroll));
        const wave = Math.sin(progress * Math.PI * 2.35);
        const counterWave = Math.cos(progress * Math.PI * 1.7);

        page.style.setProperty('--home-depth-scroll', `${(-18 - progress * 104).toFixed(2)}px`);
        page.style.setProperty('--home-depth-shift', `${(wave * 52).toFixed(2)}px`);
        page.style.setProperty('--home-depth-scroll-alt', `${(24 + progress * 94).toFixed(2)}px`);
        page.style.setProperty('--home-depth-shift-alt', `${(counterWave * -44).toFixed(2)}px`);
        page.style.setProperty('--home-depth-opacity', `${(0.82 + Math.sin(progress * Math.PI * 3.1) * 0.07).toFixed(3)}`);
        page.style.setProperty('--home-depth-brightness', `${(0.91 + (counterWave + 1) * 0.025).toFixed(3)}`);
      };
      const schedule = () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      };

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      update();
    };

    const prioritizeCategoryNavigator = (root = document) => {
      root.querySelectorAll('[data-premium-navigator]').forEach((navigator) => {
        const tablist = navigator.querySelector('.premium-navigator__tabs');
        const categoryTab = navigator.querySelector('[data-navigator-tab="category"]');
        const bikeTab = navigator.querySelector('[data-navigator-tab="bike"]');
        const categoryPanel = navigator.querySelector('[data-navigator-panel="category"]');
        const bikePanel = navigator.querySelector('[data-navigator-panel="bike"]');

        if (!tablist || !categoryTab || !bikeTab || !categoryPanel || !bikePanel) return;

        const categoryIndex = categoryTab.querySelector('span');
        const bikeIndex = bikeTab.querySelector('span');
        if (categoryIndex) categoryIndex.textContent = '01';
        if (bikeIndex) bikeIndex.textContent = '02';

        if (tablist.firstElementChild !== categoryTab) {
          tablist.insertBefore(categoryTab, bikeTab);
        }
        const requestedMode = new URLSearchParams(window.location.search).get('shop');
        const showBike = requestedMode === 'bike';
        categoryTab.setAttribute('aria-selected', String(!showBike));
        categoryTab.tabIndex = showBike ? -1 : 0;
        bikeTab.setAttribute('aria-selected', String(showBike));
        bikeTab.tabIndex = showBike ? 0 : -1;
        categoryPanel.hidden = showBike;
        bikePanel.hidden = !showBike;
      });
    };

    const scheduleCategoryNavigator = (root = document) => {
      requestAnimationFrame(() => prioritizeCategoryNavigator(root));
    };

    const stabilizeCategoryNavigator = (root = document) => {
      root.querySelectorAll('[data-premium-navigator]').forEach((navigator) => {
        if (navigator.dataset.categoryDefaultGuard === 'true') return;
        navigator.dataset.categoryDefaultGuard = 'true';

        navigator.addEventListener('click', (event) => {
          if (event.isTrusted && event.target.closest('[data-navigator-tab]')) {
            navigator.dataset.navigatorInteracted = 'true';
          }
        }, { capture: true });

        [0, 80, 300, 1000, 2500, 5000, 10000].forEach((delay) => {
          window.setTimeout(() => {
            if (navigator.dataset.navigatorInteracted === 'true') return;
            prioritizeCategoryNavigator(navigator.parentElement || document);
          }, delay);
        });
      });
    };

    const activateMobileSearchPosition = (root = document) => {
      root.querySelectorAll('.header__search').forEach((search) => {
        if (search.dataset.mobileSearchPositionReady === 'true') return;
        search.dataset.mobileSearchPositionReady = 'true';
        const details = search.querySelector('details');
        const sync = () => {
          const header = document.querySelector('.section-header');
          if (!header) return;
          const headerBottom = `${Math.max(0, header.getBoundingClientRect().bottom).toFixed(1)}px`;
          search.style.setProperty('--header-search-top', headerBottom);
          search.style.setProperty('--mobile-search-top', headerBottom);
        };
        details?.addEventListener('toggle', () => {
          if (details.open) sync();
        });
        window.addEventListener('resize', sync, { passive: true });
        sync();
      });
    };

    const selector = [
      '.premium-fit__card',
      '.premium-carbon__card',
      '.premium-frameguards__card',
      '.premium-budget__product',
      '.premium-product-card',
      '.menu-drawer__shop-choice',
      '.menu-drawer__wheel-builder-link',
      '.template-collection .card-wrapper',
      '.template-list-collections .card-wrapper'
    ].join(',');

    const activate = (root = document) => {
      if (window.innerWidth < 750 || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      root.querySelectorAll(selector).forEach((card) => {
        if (card.dataset.gravityReady === 'true') return;
        card.dataset.gravityReady = 'true';

        let frame;
        const reset = () => {
          cancelAnimationFrame(frame);
          card.style.setProperty('--gravity-x', '0px');
          card.style.setProperty('--gravity-y', '0px');
        };

        card.addEventListener('pointermove', (event) => {
          const bounds = card.getBoundingClientRect();
          const currentX = Number.parseFloat(card.style.getPropertyValue('--gravity-x')) || 0;
          const currentY = Number.parseFloat(card.style.getPropertyValue('--gravity-y')) || 0;
          const stableLeft = bounds.left - currentX;
          const stableTop = bounds.top - currentY;
          const isMenuFeature = card.matches('.menu-drawer__shop-choice,.menu-drawer__wheel-builder-link');
          const x = ((event.clientX - stableLeft) / bounds.width - 0.5) * (isMenuFeature ? 2.4 : 3.2);
          const y = ((event.clientY - stableTop) / bounds.height - 0.5) * (isMenuFeature ? 2 : 2.6);

          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            card.style.setProperty('--gravity-x', `${x.toFixed(2)}px`);
            card.style.setProperty('--gravity-y', `${y.toFixed(2)}px`);
          });
        }, { passive: true });

        card.addEventListener('pointerleave', reset);
        card.addEventListener('blur', reset, true);
      });
    };

    /* The canonical launcher has its own guarded motion controller. Excluding
       it here prevents two animation loops from fighting over its position. */
    const builderSelector = '.premium-home .wheel-builder-launch:not([data-wheel-global-guard])';
    const builderTargets = new Set();
    const pointer = { x: 0, y: 0, active: false };
    const motionAllowed = window.matchMedia('(prefers-reduced-motion: no-preference)');

    const activateBuilderMotion = (root = document) => {
      if (!motionAllowed.matches) return;

      root.querySelectorAll(builderSelector).forEach((target, index) => {
        if (target.dataset.builderMotionReady === 'true') return;
        target.dataset.builderMotionReady = 'true';
        target.dataset.builderMotionPhase = String(index * Math.PI);
        builderTargets.add(target);
      });
    };

    const trackPointer = (event) => {
      pointer.x = event.clientX;
      pointer.y = event.clientY;
      pointer.active = true;
    };

    const clearPointer = () => {
      pointer.active = false;
    };

    const animateBuilderMotion = (time) => {
      if (document.documentElement.classList.contains('cart-rewards-overlay-open')) {
        requestAnimationFrame(animateBuilderMotion);
        return;
      }

      builderTargets.forEach((target) => {
        if (!target.isConnected) {
          builderTargets.delete(target);
          return;
        }

        const bounds = target.getBoundingClientRect();
        if (bounds.width === 0 || bounds.height === 0) return;

        const phase = Number(target.dataset.builderMotionPhase || 0);
        const angle = time * 0.00055 + phase;
        const driftX = Math.cos(angle) * 2.4;
        const driftY = Math.sin(angle) * 1.9;
        let gravityX = 0;
        let gravityY = 0;

        if (pointer.active) {
          const centerX = bounds.left + bounds.width / 2;
          const centerY = bounds.top + bounds.height / 2;
          const deltaX = pointer.x - centerX;
          const deltaY = pointer.y - centerY;
          const distance = Math.hypot(deltaX, deltaY);
          const proximity = Math.max(0, 1 - distance / 240);

          if (proximity > 0 && distance > 0) {
            gravityX = (deltaX / distance) * 7 * proximity;
            gravityY = (deltaY / distance) * 6 * proximity;
          }
        }

        target.style.setProperty('--drift-x', `${driftX.toFixed(2)}px`);
        target.style.setProperty('--drift-y', `${driftY.toFixed(2)}px`);
        target.style.setProperty('--gravity-x', `${gravityX.toFixed(2)}px`);
        target.style.setProperty('--gravity-y', `${gravityY.toFixed(2)}px`);
      });

      requestAnimationFrame(animateBuilderMotion);
    };

    const normalizeUtilityArrows = (root = document) => {
      root.querySelectorAll('.policy-contact-link > span').forEach((arrow) => {
        arrow.textContent = '→';
      });
    };

    const normalizeFooterContactLink = (root = document) => {
      root.querySelectorAll('.policies a[href*="/policies/contact-information"]').forEach((link) => {
        link.setAttribute('href', '/pages/contact');
      });
    };

    activateHomepageDepth();
    activate();
    activateBuilderMotion();
    activateMobileSearchPosition();
    normalizeUtilityArrows();
    normalizeFooterContactLink();
    prioritizeCategoryNavigator();
    document.documentElement.dataset.categoryDefaultGuardVersion = '4';
    stabilizeCategoryNavigator();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        stabilizeCategoryNavigator();
        scheduleCategoryNavigator();
      }, { once: true });
    } else {
      stabilizeCategoryNavigator();
      scheduleCategoryNavigator();
    }
    if (motionAllowed.matches) {
      document.addEventListener('pointermove', trackPointer, { passive: true });
      document.addEventListener('pointerleave', clearPointer);
      window.addEventListener('blur', clearPointer);
      requestAnimationFrame(animateBuilderMotion);
    }

    document.addEventListener('shopify:section:load', (event) => {
      activateHomepageDepth();
      activate(event.target);
      activateBuilderMotion(event.target);
      activateMobileSearchPosition(event.target);
      normalizeUtilityArrows(event.target);
      normalizeFooterContactLink(event.target);
      stabilizeCategoryNavigator(event.target);
      scheduleCategoryNavigator(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.scrollDirectionThreshold = 8;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = scrollTop - this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (Math.abs(scrollDelta) < this.scrollDirectionThreshold && scrollTop > this.headerBounds.bottom) return;

      if (scrollDelta > 0 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollDelta < 0 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const navigators = document.querySelectorAll('[data-premium-navigator]');
    navigators.forEach((navigator) => {
      let tabs = [...navigator.querySelectorAll('[data-navigator-tab]')];
      const panels = [...navigator.querySelectorAll('[data-navigator-panel]')];
      const categoryTab = tabs.find((tab) => tab.dataset.navigatorTab === 'category');
      if (categoryTab && tabs[0] !== categoryTab) {
        categoryTab.parentElement.prepend(categoryTab);
        tabs = [...navigator.querySelectorAll('[data-navigator-tab]')];
      }
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.navigatorTab;
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => { panel.hidden = panel.dataset.navigatorPanel !== target; });
        });
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          next.focus();
          next.click();
        });
      });
      const requestedMode = new URLSearchParams(window.location.search).get('shop');
      const requestedTab = tabs.find((tab) => tab.dataset.navigatorTab === requestedMode);
      if (requestedTab) requestedTab.click();
      else if (categoryTab) categoryTab.click();
      else if (tabs[0]) tabs[0].click();
    });

    document.querySelectorAll('[data-smooth-carousel]').forEach((carousel) => {
      if (carousel.dataset.smoothCarouselReady === 'true') return;
      carousel.dataset.smoothCarouselReady = 'true';

      const track = carousel.querySelector('[data-carousel-track]');
      const arrows = [...carousel.querySelectorAll('[data-carousel-arrow]')];
      if (!track) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const driftSpeed = Number(carousel.dataset.carouselSpeed || .027);
      let direction = 1;
      let pauseUntil = 0;
      let hovering = false;
      let focused = false;
      let previousTime = performance.now();
      let driftPosition = track.scrollLeft;
      const loopOrigins = carousel.hasAttribute('data-loop-carousel') ? [...track.querySelectorAll('[data-loop-origin]')] : [];
      const loopLength = loopOrigins.length === 3 ? loopOrigins[2].offsetLeft - loopOrigins[1].offsetLeft : 0;
      const loopStart = loopOrigins.length === 3 ? loopOrigins[1].offsetLeft - loopOrigins[0].offsetLeft : 0;
      if (loopLength > 0) {
        track.scrollLeft = loopStart;
        driftPosition = track.scrollLeft;
      }

      const normalizeLoop = () => {
        if (loopLength <= 0) return;
        const middleStart = loopStart;
        const endStart = loopStart + loopLength;
        let wrapped = false;
        if (track.scrollLeft >= endStart) {
          track.scrollLeft -= loopLength;
          wrapped = true;
        } else if (track.scrollLeft < middleStart) {
          track.scrollLeft += loopLength;
          wrapped = true;
        }
        if (wrapped) driftPosition = track.scrollLeft;
        return wrapped;
      };

      const pauseFor = (duration = 2600) => { pauseUntil = performance.now() + duration; };
      const cardStep = () => {
        const card = track.firstElementChild;
        if (!card) return Math.min(track.clientWidth * .82, 560);
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
        return card.getBoundingClientRect().width + gap;
      };

      arrows.forEach((button) => {
        button.addEventListener('click', () => {
          const buttonDirection = Number(button.dataset.carouselArrow) || 1;
          direction = buttonDirection;
          pauseFor(4200);
          track.scrollBy({ left: buttonDirection * cardStep(), behavior: 'smooth' });
        });
      });

      carousel.addEventListener('pointerenter', () => { hovering = true; });
      carousel.addEventListener('pointerleave', () => { hovering = false; pauseFor(700); });
      carousel.addEventListener('focusin', () => { focused = true; });
      carousel.addEventListener('focusout', () => { focused = carousel.contains(document.activeElement); pauseFor(900); });
      track.addEventListener('wheel', () => pauseFor(3200), { passive: true });
      track.addEventListener('pointerdown', () => pauseFor(3600), { passive: true });
      track.addEventListener('touchstart', () => pauseFor(3600), { passive: true });
      track.addEventListener('scroll', () => {
        if (loopLength > 0 && track.clientWidth >= 750) {
          normalizeLoop();
          return;
        }
        const max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft <= 1) direction = 1;
        if (track.scrollLeft >= max - 1) direction = -1;
      }, { passive: true });

      const drift = (time) => {
        const elapsed = Math.min(time - previousTime, 50);
        previousTime = time;
        const max = track.scrollWidth - track.clientWidth;
        const rewardsOpen = document.documentElement.classList.contains('cart-rewards-overlay-open');
        const canMove = max > 2 && track.clientWidth >= 750 && !reducedMotion.matches && !document.hidden && !rewardsOpen && !hovering && !focused && time >= pauseUntil;
        if (canMove) {
          if (loopLength > 0) normalizeLoop();
          else {
            if (track.scrollLeft >= max - 1) direction = -1;
            if (track.scrollLeft <= 1) direction = 1;
          }
          driftPosition = loopLength > 0 ? driftPosition + direction * elapsed * driftSpeed : Math.max(0, Math.min(max, driftPosition + direction * elapsed * driftSpeed));
          track.scrollLeft = driftPosition;
        } else {
          driftPosition = track.scrollLeft;
        }
        requestAnimationFrame(drift);
      };
      requestAnimationFrame(drift);
    });

    document.querySelectorAll('[data-premium-standard]').forEach((standard) => {
      const tabs = [...standard.querySelectorAll('[data-standard-tab]')];
      const panels = [...standard.querySelectorAll('[data-standard-panel]')];
      const selectTab = (tab) => {
        const target = tab.dataset.standardTab;
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.standardPanel !== target; });
      };
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => selectTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const forward = event.key === 'ArrowDown' || event.key === 'ArrowRight';
          const next = tabs[(tabs.indexOf(tab) + (forward ? 1 : -1) + tabs.length) % tabs.length];
          next.focus();
          selectTab(next);
        });
      });
      if (tabs[0]) selectTab(tabs[0]);
    });

    document.querySelectorAll('[data-community-gallery]').forEach((gallery) => {
      const track = gallery.querySelector('[data-gallery-track]');
      if (!track) return;
      gallery.querySelectorAll('[data-gallery-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = Number(button.dataset.galleryScroll) || 1;
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const step = Math.min(track.clientWidth * .78, 560);
          const edgeTolerance = 4;
          let target = track.scrollLeft + (direction * step);

          if (direction < 0 && track.scrollLeft <= edgeTolerance) {
            target = maxScroll;
          } else if (direction > 0 && track.scrollLeft >= maxScroll - edgeTolerance) {
            target = 0;
          } else {
            target = Math.max(0, Math.min(maxScroll, target));
          }

          track.scrollTo({ left: target, behavior: 'smooth' });
        });
      });
    });

    document.querySelectorAll('[data-budget-shop]').forEach((shop) => {
      const buttons = [...shop.querySelectorAll('[data-budget-filter]')];
      const panels = [...shop.querySelectorAll('[data-budget-panel]')];
      const selectFilter = (button) => {
        const filter = button.dataset.budgetFilter;
        const update = () => {
          buttons.forEach((item) => {
            const selected = item === button;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.budgetPanel !== filter;
          });
        };
        if (document.startViewTransition) document.startViewTransition(update);
        else update();
      };
      buttons.forEach((button) => button.addEventListener('click', () => selectFilter(button)));
      buttons.forEach((button, index) => button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        buttons[next].focus();
        selectFilter(buttons[next]);
      }));
      if (buttons[0]) selectFilter(buttons[0]);
    });

    document.querySelectorAll('[data-wheel-customizer]').forEach((customizer) => {
      if (customizer.dataset.wheelReady === 'true') return;
      customizer.dataset.wheelReady = 'true';

      const summaries = [...customizer.querySelectorAll('[data-wheel-summary]')];
      const stages = [...customizer.querySelectorAll('[data-wheel-stage]')].map((stage) => {
        const canvas = stage.querySelector('[data-wheel-canvas]');
        const maskImages = Object.fromEntries(
          [...stage.querySelectorAll('[data-wheel-mask-part]')].map((maskImage) => [maskImage.dataset.wheelMaskPart, maskImage])
        );
        return {
          stage,
          photo: stage.querySelector('[data-wheel-photo]'),
          maskImages,
          canvas,
          context: canvas?.getContext('2d', { willReadFrequently: true }),
          parts: new Set((stage.dataset.wheelParts || 'rim,spoke,hub').split(',')),
          profile: stage.dataset.wheelMaskProfile || 'front',
          renderer: null
        };
      });
      const chromeGradient = 'linear-gradient(135deg,#666 0,#fff 35%,#8c8c8c 58%,#f8f8f6 78%,#777 100%)';
      const colorParser = document.createElement('canvas');
      colorParser.width = 1;
      colorParser.height = 1;
      const colorParserContext = colorParser.getContext('2d', { willReadFrequently: true });
      const aliases = {
        chrome: { color: '#dfe3e6', name: 'Shiny chrome', mode: 'chrome' },
        black: { color: '#101012', name: 'Black', mode: 'black' }
      };

      const parseColor = (value) => {
        if (!colorParserContext || !window.CSS?.supports?.('color', value)) return null;
        colorParserContext.clearRect(0, 0, 1, 1);
        colorParserContext.fillStyle = value;
        colorParserContext.fillRect(0, 0, 1, 1);
        const result = colorParserContext.getImageData(0, 0, 1, 1).data;
        return [result[0], result[1], result[2]];
      };

      const resolveFinish = (finish) => ({ ...finish, rgb: finish.rgb || parseColor(finish.color) || [128, 128, 128] });
      const selections = { rim: 'Shiny chrome', spoke: 'Shiny chrome', hub: 'Black' };
      const finishes = {
        rim: resolveFinish(aliases.chrome),
        spoke: resolveFinish(aliases.chrome),
        hub: resolveFinish(aliases.black)
      };
      const cartRoot = customizer.querySelector('[data-wheel-cart]');
      const cartDataElement = cartRoot?.querySelector('[data-wheel-products]');
      let cartData = { currency: 'USD', models: [] };
      try {
        if (cartDataElement) cartData = JSON.parse(cartDataElement.textContent);
      } catch (error) {
        cartData = { currency: 'USD', models: [] };
      }
      const modelSelect = cartRoot?.querySelector('[data-wheel-model]');
      const variantInput = cartRoot?.querySelector('[data-wheel-variant-id]');
      const cartButton = cartRoot?.querySelector('[data-wheel-add]');
      const cartPrice = cartRoot?.querySelector('[data-wheel-price]');
      const cartProductTitle = cartRoot?.querySelector('[data-wheel-product-title]');
      const cartProductLink = cartRoot?.querySelector('[data-wheel-product-link]');
      const cartProperties = Object.fromEntries([...customizer.querySelectorAll('[data-wheel-property]')].map((input) => [input.dataset.wheelProperty, input]));
      const liveStatus = customizer.querySelector('[data-wheel-live]');
      const stockStart = customizer.querySelector('[data-wheel-stock-start]');
      const stockStatus = stockStart?.querySelector('[data-wheel-stock-status]');
      const compareButton = customizer.querySelector('[data-wheel-compare]');
      const compareLabel = customizer.querySelector('[data-wheel-compare-label]');
      const compareControl = customizer.querySelector('[data-wheel-compare-control]');
      const compareRange = customizer.querySelector('[data-wheel-compare-range]');
      const zoomOutput = customizer.querySelector('[data-wheel-zoom-value]');
      const zoomRange = customizer.querySelector('[data-wheel-zoom-range]');
      const zoomButtons = [...customizer.querySelectorAll('[data-wheel-zoom]')];
      let zoomLevel = 1;
      let restoringState = true;
      const announce = (message) => {
        if (!liveStatus) return;
        liveStatus.textContent = '';
        window.requestAnimationFrame(() => { liveStatus.textContent = message; });
      };

      const wheelStockState = () => {
        if (selections.rim === 'Shiny chrome' && selections.spoke === 'Shiny chrome' && selections.hub === 'Shiny chrome') return 'chrome';
        if (selections.rim === 'Black' && selections.spoke === 'Black' && selections.hub === 'Black') return 'black';
        return 'mix';
      };
      const updateWheelStockStart = () => {
        const state = wheelStockState();
        stockStart?.querySelectorAll('[data-wheel-stock-preset]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.wheelStockPreset === state));
        });
        if (stockStatus) stockStatus.textContent = state === 'chrome'
          ? stockStart.dataset.statusChrome
          : state === 'black'
            ? stockStart.dataset.statusBlack
            : stockStart.dataset.statusCustom;
      };
      const currentState = () => ({
        rim: selections.rim,
        spoke: selections.spoke,
        hub: selections.hub,
        fitment: modelSelect?.value || 'lbx'
      });
      const persistState = () => {
        if (restoringState) return;
        const state = currentState();
        try { window.localStorage.setItem('wheelBuilder44Tints', JSON.stringify(state)); } catch (error) {}
        if (window.location.pathname.includes('/pages/emoto-wheel-builder')) {
          const url = new URL(window.location.href);
          Object.entries(state).forEach(([key, value]) => url.searchParams.set(key, value));
          window.history.replaceState({}, '', url);
        }
      };
      const journey = customizer.querySelector('[data-wheel-journey]');
      const journeySteps = [...customizer.querySelectorAll('[data-wheel-journey-step]')];
      if (journey) {
        journey.classList.add('is-scroll-ready');
        const revealAllJourneySteps = () => {
          journeySteps.forEach((step) => step.classList.add('is-revealed'));
          journey.style.setProperty('--journey-progress', '1');
        };
        const isMobileHomepageJourney = customizer.classList.contains('wheel-customizer--home-launch') && window.matchMedia('(max-width: 749px)').matches;
        if (isMobileHomepageJourney && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          let journeyFrame = 0;
          const updateMobileJourney = () => {
            journeyFrame = 0;
            const bounds = journey.getBoundingClientRect();
            const startLine = window.innerHeight * 0.88;
            const endLine = window.innerHeight * 0.22;
            const distance = Math.max(1, bounds.height + startLine - endLine);
            const progress = Math.max(0, Math.min(1, (startLine - bounds.top) / distance));
            const thresholds = [0.04, 0.19, 0.34, 0.49];
            journeySteps.forEach((step, index) => {
              step.classList.toggle('is-revealed', progress >= thresholds[index]);
            });
            journey.style.setProperty('--journey-progress', String(Math.min(1, progress / 0.64)));
          };
          const scheduleMobileJourney = () => {
            if (journeyFrame) return;
            journeyFrame = window.requestAnimationFrame(updateMobileJourney);
          };
          window.addEventListener('scroll', scheduleMobileJourney, { passive: true });
          window.addEventListener('resize', scheduleMobileJourney, { passive: true });
          updateMobileJourney();
        } else if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          revealAllJourneySteps();
        } else {
          const journeyObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                journeySteps.forEach((step) => step.classList.add('is-revealed'));
                journey.style.setProperty('--journey-progress', '1');
              } else {
                journeySteps.forEach((step) => step.classList.remove('is-revealed'));
                journey.style.setProperty('--journey-progress', '0');
              }
            });
          }, { threshold: 0.22, rootMargin: '-8% 0px -8% 0px' });
          journeyObserver.observe(journey);
        }
      }
      const variantFinish = (part) => {
        const finish = finishes[part];
        if (finish.mode === 'chrome') return 'chrome';
        if (finish.mode === 'black') return 'black';
        const namedFinish = finish.name.toLowerCase();
        if (part === 'rim' && ['gold', 'brown', 'red'].includes(namedFinish)) return namedFinish;
        return 'custom';
      };
      const normalizeVariantFinish = (value) => {
        const normalized = String(value || '').trim().toLowerCase();
        return normalized.startsWith('custom') ? 'custom' : normalized;
      };
      const formatMoney = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cartData.currency || 'USD' }).format(Number(amount || 0) / 100);
      const syncCartForm = () => {
        if (!cartRoot || !modelSelect || !variantInput || !cartButton) return;
        const setFormValue = (input, value) => {
          if (!input) return;
          input.value = value || '';
          input.setAttribute('value', value || '');
        };
        const model = cartData.models.find((entry) => entry.key === modelSelect.value) || cartData.models[0];
        const rimFinish = variantFinish('rim');
        const hubFinish = variantFinish('hub');
        const variant = model?.variants?.find((entry) => entry.available && normalizeVariantFinish(entry.option2) === rimFinish && normalizeVariantFinish(entry.option3) === hubFinish);
        variantInput.disabled = !variant;
        setFormValue(variantInput, variant?.id || '');
        cartButton.disabled = !variant;
        cartButton.setAttribute('aria-disabled', String(!variant));
        if (cartPrice) cartPrice.textContent = variant ? formatMoney(variant.price) : 'Unavailable';
        if (cartProductTitle) cartProductTitle.textContent = model?.title || '';
        if (cartProductLink && model?.url) cartProductLink.href = model.url;
        setFormValue(cartProperties.fitment, model?.label || '');
        setFormValue(cartProperties.rim, selections.rim);
        setFormValue(cartProperties.spoke, selections.spoke);
        setFormValue(cartProperties.hub, selections.hub);
      };
      let renderQueued = false;

      const clamp = (value, minimum = 0, maximum = 1) => Math.max(minimum, Math.min(maximum, value));
      const smoothstep = (minimum, maximum, value) => {
        const normalized = clamp((value - minimum) / Math.max(0.0001, maximum - minimum));
        return normalized * normalized * (3 - 2 * normalized);
      };
      const toLinear = (value) => {
        const normalized = value / 255;
        return normalized <= 0.04045 ? normalized / 12.92 : Math.pow((normalized + 0.055) / 1.055, 2.4);
      };
      const toSrgb = (value) => {
        const normalized = clamp(value);
        const encoded = normalized <= 0.0031308 ? normalized * 12.92 : 1.055 * Math.pow(normalized, 1 / 2.4) - 0.055;
        return Math.round(clamp(encoded) * 255);
      };

      const createMaskList = (maskPixels, channel, part) => {
        const indexes = [];
        const weights = [];
        const thresholds = part === 'hub' ? [0.025, 0.82] : part === 'spoke' ? [0.02, 0.32] : [0.025, 0.5];
        for (let offset = 0; offset < maskPixels.length; offset += 4) {
          const rawWeight = maskPixels[offset + channel] / 255;
          if (rawWeight <= thresholds[0]) continue;
          const refinedWeight = smoothstep(thresholds[0], thresholds[1], rawWeight);
          if (refinedWeight > 0.01) {
            indexes.push(offset);
            weights.push(Math.round(refinedWeight * 255));
          }
        }
        return { indexes: new Uint32Array(indexes), weights: new Uint8Array(weights) };
      };

      const applyFinishToPixels = (framePixels, basePixels, mask, finish, part) => {
        if (finish.mode === 'chrome') return;
        const targetLinear = finish.rgb.map(toLinear);
        const targetSrgb = finish.rgb.map((channel) => channel / 255);
        const isBlack = finish.mode === 'black';
        const isHub = part === 'hub';

        for (let index = 0; index < mask.indexes.length; index += 1) {
          const offset = mask.indexes[index];
          const blendWeight = mask.weights[index] / 255;
          const sourceRed = basePixels[offset];
          const sourceGreen = basePixels[offset + 1];
          const sourceBlue = basePixels[offset + 2];
          const sourceLuminance = (sourceRed * 0.2126 + sourceGreen * 0.7152 + sourceBlue * 0.0722) / 255;
          let mappedRgb;

          if (isHub) {
            const sourceLinear = [toLinear(sourceRed), toLinear(sourceGreen), toLinear(sourceBlue)];
            const luminance = sourceLinear[0] * 0.2126 + sourceLinear[1] * 0.7152 + sourceLinear[2] * 0.0722;
            let mappedLinear;
            if (isBlack) {
              const detail = 0.004 + Math.pow(luminance, 0.76) * 0.115;
              const reflection = smoothstep(0.74, 1, luminance) * 0.06;
              mappedLinear = [detail + reflection, detail + reflection, detail + reflection];
            } else {
              const materialLight = 0.1 + Math.pow(luminance, 0.72) * 0.9;
              const specular = smoothstep(0.68, 0.98, luminance) * 0.28;
              mappedLinear = targetLinear.map((channel) => channel * materialLight * (1 - specular) + luminance * specular);
            }
            mappedRgb = mappedLinear.map((channel) => toSrgb(channel));
          } else if (isBlack) {
            const detail = 0.018 + Math.pow(sourceLuminance, 0.75) * 0.155;
            const reflection = smoothstep(0.78, 1, sourceLuminance) * 0.065;
            const blackValue = Math.round(clamp(detail + reflection) * 255);
            mappedRgb = [blackValue, blackValue, blackValue];
          } else {
            const materialShade = part === 'rim'
              ? 0.56 + Math.pow(sourceLuminance, 0.8) * 0.52
              : 0.4 + Math.pow(sourceLuminance, 0.75) * 0.65;
            const highlightAmount = smoothstep(0.72, 0.995, sourceLuminance) * (part === 'spoke' ? 0.28 : 0.22);
            mappedRgb = targetSrgb.map((channel) => {
              const shadedColor = clamp(channel * materialShade);
              const tintedHighlight = channel * 0.9 + 0.1;
              return Math.round(clamp(shadedColor + (tintedHighlight - shadedColor) * highlightAmount) * 255);
            });
          }

          framePixels[offset] += (mappedRgb[0] - framePixels[offset]) * blendWeight;
          framePixels[offset + 1] += (mappedRgb[1] - framePixels[offset + 1]) * blendWeight;
          framePixels[offset + 2] += (mappedRgb[2] - framePixels[offset + 2]) * blendWeight;
        }
      };

      const renderWheel = (entry) => {
        if (!entry.renderer || !entry.context) return;
        const { renderer } = entry;
        renderer.frame.data.set(renderer.basePixels);
        ['rim', 'spoke', 'hub'].forEach((part) => {
          if (!entry.parts.has(part)) return;
          applyFinishToPixels(renderer.frame.data, renderer.basePixels, renderer.masks[part], finishes[part], part);
        });
        entry.context.putImageData(renderer.frame, 0, 0);
        entry.stage.dataset.wheelRenderState = [...entry.parts].map((part) => `${part}:${finishes[part].mode}`).join(',');
        entry.canvas.classList.add('is-ready');
      };

      const scheduleRender = () => {
        if (renderQueued) return;
        renderQueued = true;
        window.requestAnimationFrame(() => {
          renderQueued = false;
          stages.forEach(renderWheel);
        });
      };

      const initializeRenderer = (entry) => {
        const { photo, maskImages, canvas, context } = entry;
        const requiredMaskImages = [...entry.parts].map((part) => maskImages[part]).filter(Boolean);
        if (entry.renderer || !context || !photo?.naturalWidth || requiredMaskImages.length !== entry.parts.size || requiredMaskImages.some((maskImage) => !maskImage.naturalWidth)) return;
        try {
          canvas.width = photo.naturalWidth;
          canvas.height = photo.naturalHeight;
          context.drawImage(photo, 0, 0, canvas.width, canvas.height);
          const baseData = context.getImageData(0, 0, canvas.width, canvas.height);
          const masks = {};
          const maskChannels = { rim: 0, spoke: 1, hub: 2 };
          entry.parts.forEach((part) => {
            const maskCanvas = document.createElement('canvas');
            maskCanvas.width = canvas.width;
            maskCanvas.height = canvas.height;
            const maskContext = maskCanvas.getContext('2d', { willReadFrequently: true });
            maskContext.drawImage(maskImages[part], 0, 0, canvas.width, canvas.height);
            const maskPixels = maskContext.getImageData(0, 0, canvas.width, canvas.height).data;
            masks[part] = createMaskList(maskPixels, maskChannels[part], part);
          });
          entry.renderer = {
            basePixels: new Uint8ClampedArray(baseData.data),
            frame: new ImageData(new Uint8ClampedArray(baseData.data), canvas.width, canvas.height),
            masks
          };
          entry.stage.dataset.wheelMaskCounts = [...entry.parts].map((part) => `${part}:${masks[part].indexes.length}`).join(',');
          renderWheel(entry);
          entry.stage.setAttribute('aria-busy', 'false');
        } catch (error) {
          canvas.classList.remove('is-ready');
          entry.stage.setAttribute('aria-busy', 'false');
        }
      };

      stages.forEach((entry) => {
        entry.photo?.addEventListener('load', () => initializeRenderer(entry), { once: true });
        Object.values(entry.maskImages).forEach((maskImage) => maskImage.addEventListener('load', () => initializeRenderer(entry), { once: true }));
        initializeRenderer(entry);
      });

      const dialog = customizer.querySelector('[data-wheel-dialog]');
      let dialogTrigger = null;
      customizer.querySelectorAll('[data-wheel-view-open]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!dialog) return;
          dialogTrigger = button;
          const openScrollY = window.scrollY || document.documentElement.scrollTop || 0;
          const centerDialogInViewport = () => {
            dialog.style.top = `${openScrollY + (window.innerHeight / 2)}px`;
          };
          centerDialogInViewport();
          if (!dialog.open) dialog.showModal();
          dialog.scrollTop = 0;
          window.requestAnimationFrame(() => {
            window.scrollTo({ top: openScrollY, left: 0, behavior: 'instant' });
            centerDialogInViewport();
            dialog.querySelector('[data-wheel-view-close]')?.focus({ preventScroll: true });
          });
          scheduleRender();
        });
      });
      customizer.querySelectorAll('[data-wheel-view-close]').forEach((button) => {
        button.addEventListener('click', () => dialog?.close());
      });
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog?.addEventListener('close', () => dialogTrigger?.focus());

      const areaLauncher = customizer.querySelector('[data-wheel-area-launch]');
      if (areaLauncher && areaLauncher.dataset.gravityReady !== 'true') {
        areaLauncher.dataset.gravityReady = 'true';
        const finePointer = window.matchMedia('(min-width: 750px) and (pointer: fine)');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let currentX = 0;
        let currentY = 0;
        let targetX = 0;
        let targetY = 0;
        let gravityFrame = 0;
        const animateGravity = () => {
          gravityFrame = 0;
          currentX += (targetX - currentX) * .16;
          currentY += (targetY - currentY) * .16;
          areaLauncher.style.setProperty('--builder-entry-x', `${currentX.toFixed(2)}px`);
          areaLauncher.style.setProperty('--builder-entry-y', `${currentY.toFixed(2)}px`);
          if (Math.abs(targetX - currentX) > .08 || Math.abs(targetY - currentY) > .08) gravityFrame = window.requestAnimationFrame(animateGravity);
        };
        const queueGravity = () => {
          if (!gravityFrame) gravityFrame = window.requestAnimationFrame(animateGravity);
        };
        document.addEventListener('pointermove', (event) => {
          if (!finePointer.matches || reduceMotion.matches) return;
          const bounds = areaLauncher.getBoundingClientRect();
          const deltaX = event.clientX - (bounds.left + bounds.width / 2 - currentX);
          const deltaY = event.clientY - (bounds.top + bounds.height / 2 - currentY);
          const influence = Math.max(0, 1 - Math.hypot(deltaX, deltaY) / 420);
          targetX = Math.max(-13, Math.min(13, deltaX * .055 * influence));
          targetY = Math.max(-9, Math.min(9, deltaY * .045 * influence));
          queueGravity();
        }, { passive: true });
        window.addEventListener('blur', () => {
          targetX = 0;
          targetY = 0;
          queueGravity();
        });
      }

      const setPressed = (part, mode) => {
        customizer.querySelectorAll(`[data-wheel-part="${part}"], [data-wheel-custom="${part}"]`).forEach((button) => {
          const isCustomButton = button.dataset.wheelCustom === part;
          const isPressed = mode === 'custom'
            ? isCustomButton
            : !isCustomButton && button.dataset.wheelMode === mode;
          button.setAttribute('aria-pressed', String(isPressed));
          if (isCustomButton) button.setAttribute('aria-expanded', String(mode === 'custom'));
        });
      };

      const setPickerVisibility = (part, visible) => {
        customizer.querySelectorAll(`[data-wheel-picker="${part}"]`).forEach((picker) => {
          picker.hidden = !visible;
        });
      };

      const selectionFromSelect = (select) => {
        const option = select?.selectedOptions?.[0];
        if (!option) return null;
        return { color: option.value, name: option.textContent.trim(), mode: 'custom' };
      };

      const applySelection = (part, selection) => {
        finishes[part] = resolveFinish(selection);
        selections[part] = selection.name;
        setPressed(part, selection.mode);
        setPickerVisibility(part, selection.mode === 'custom');

        customizer.querySelectorAll(`[data-wheel-control="${part}"]`).forEach((control) => {
          const output = control.querySelector('output');
          if (output) output.textContent = selection.name;
        });
        customizer.querySelectorAll(`[data-wheel-preview="${part}"]`).forEach((preview) => {
          preview.style.background = selection.mode === 'chrome' ? chromeGradient : selection.color;
        });
        if (selection.mode === 'custom') {
          customizer.querySelectorAll(`[data-wheel-select="${part}"]`).forEach((select) => {
            select.value = selection.color;
          });
        }
        summaries.forEach((summary) => { summary.textContent = `HUB: ${selections.hub} · RIM: ${selections.rim} · SPOKE: ${selections.spoke}`; });
        syncCartForm();
        updateWheelStockStart();
        scheduleRender();
        persistState();
        announce(`${selection.name} ${part} selected.`);
      };

      customizer.querySelectorAll('[data-wheel-part]').forEach((preset) => {
        preset.addEventListener('click', () => {
          const part = preset.dataset.wheelPart;
          const selection = {
            color: preset.dataset.wheelColor,
            name: preset.dataset.wheelName,
            mode: preset.dataset.wheelMode
          };
          applySelection(part, selection);
        });
      });

      customizer.querySelectorAll('[data-wheel-custom]').forEach((customButton) => {
        customButton.addEventListener('click', () => {
          const part = customButton.dataset.wheelCustom;
          const control = customButton.closest(`[data-wheel-control="${part}"]`);
          const select = control?.querySelector(`[data-wheel-select="${part}"]`)
            || customizer.querySelector(`[data-wheel-select="${part}"]`);
          const selection = selectionFromSelect(select);
          if (!selection) return;
          applySelection(part, selection);
          window.requestAnimationFrame(() => select.focus());
        });
      });

      customizer.querySelectorAll('[data-wheel-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const part = select.dataset.wheelSelect;
          const selection = selectionFromSelect(select);
          if (selection) applySelection(part, selection);
        });
      });
      stockStart?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-wheel-stock-preset]');
        if (!button) return;
        const preset = button.dataset.wheelStockPreset;
        if (preset === 'mix') {
          if (wheelStockState() !== 'mix') {
            applySelection('rim', aliases.chrome);
            applySelection('spoke', aliases.chrome);
            applySelection('hub', aliases.black);
          }
          updateWheelStockStart();
          customizer.querySelector('[data-wheel-control="rim"]')?.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        const finish = preset === 'chrome' ? aliases.chrome : aliases.black;
        applySelection('rim', finish);
        applySelection('spoke', finish);
        applySelection('hub', finish);
        updateWheelStockStart();
        if (!reduceMotion.matches) stockStart.animate(
          [{ transform: 'scale(.992)' }, { transform: 'scale(1.008)' }, { transform: 'scale(1)' }],
          { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' }
        );
      });
      modelSelect?.addEventListener('change', () => {
        syncCartForm();
        persistState();
        announce(`${modelSelect.selectedOptions[0]?.textContent || 'Bike'} fitment selected.`);
      });

      const selectionFromName = (part, name) => {
        if (!name) return null;
        const preset = [...customizer.querySelectorAll(`[data-wheel-part="${part}"]`)].find((button) => button.dataset.wheelName === name);
        if (preset) return { color: preset.dataset.wheelColor, name: preset.dataset.wheelName, mode: preset.dataset.wheelMode };
        const select = customizer.querySelector(`[data-wheel-select="${part}"]`);
        const option = [...(select?.options || [])].find((item) => item.textContent.trim() === name);
        return option ? { color: option.value, name: option.textContent.trim(), mode: 'custom' } : null;
      };

      const updateZoom = (nextZoom) => {
        zoomLevel = clamp(nextZoom, 1, 1.8);
        stages.forEach((entry) => entry.stage.style.setProperty('--wheel-zoom', zoomLevel.toFixed(2)));
        if (zoomOutput) zoomOutput.textContent = `${Math.round(zoomLevel * 100)}%`;
        if (zoomRange) zoomRange.value = String(Math.round(zoomLevel * 100));
        zoomButtons.forEach((button) => {
          const atLimit = button.dataset.wheelZoom === 'out' ? zoomLevel <= 1.001 : zoomLevel >= 1.799;
          button.disabled = atLimit;
        });
      };
      zoomButtons.forEach((button) => {
        button.addEventListener('click', () => updateZoom(zoomLevel + (button.dataset.wheelZoom === 'in' ? 0.1 : -0.1)));
      });
      zoomRange?.addEventListener('input', () => updateZoom(Number(zoomRange.value) / 100));
      stages.forEach((entry) => {
        entry.stage.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch' || zoomLevel <= 1.001) return;
          const bounds = entry.stage.getBoundingClientRect();
          const focusX = clamp((event.clientX - bounds.left) / bounds.width, 0.18, 0.82) * 100;
          const focusY = clamp((event.clientY - bounds.top) / bounds.height, 0.18, 0.82) * 100;
          entry.stage.style.setProperty('--wheel-focus-x', `${focusX.toFixed(1)}%`);
          entry.stage.style.setProperty('--wheel-focus-y', `${focusY.toFixed(1)}%`);
        }, { passive: true });
        entry.stage.addEventListener('pointerleave', () => {
          entry.stage.style.setProperty('--wheel-focus-x', '50%');
          entry.stage.style.setProperty('--wheel-focus-y', '50%');
        });
      });
      const updateCompareSplit = (value) => {
        const split = clamp(Number(value), 12, 88);
        stages.forEach((entry) => {
          if (entry.profile === 'front') entry.stage.style.setProperty('--compare-split', `${split}%`);
        });
      };
      compareRange?.addEventListener('input', () => updateCompareSplit(compareRange.value));
      compareButton?.addEventListener('click', () => {
        const comparing = compareButton.getAttribute('aria-pressed') !== 'true';
        compareButton.setAttribute('aria-pressed', String(comparing));
        stages.forEach((entry) => {
          if (entry.profile === 'front') entry.stage.classList.toggle('is-comparing', comparing);
        });
        if (compareControl) compareControl.hidden = !comparing;
        updateCompareSplit(compareRange?.value || 50);
        if (compareLabel) compareLabel.textContent = comparing ? customizer.dataset.wheelCompareBuild : customizer.dataset.wheelCompareOriginal;
      });
      customizer.querySelector('[data-wheel-reset]')?.addEventListener('click', () => {
        applySelection('rim', aliases.chrome);
        applySelection('spoke', aliases.chrome);
        applySelection('hub', aliases.black);
        if (modelSelect) modelSelect.value = 'lbx';
        updateZoom(1);
        syncCartForm();
        persistState();
      });
      customizer.querySelector('[data-wheel-share]')?.addEventListener('click', async () => {
        const url = new URL('/pages/emoto-wheel-builder', window.location.origin);
        Object.entries(currentState()).forEach(([key, value]) => url.searchParams.set(key, value));
        try {
          await navigator.clipboard.writeText(url.toString());
          announce(customizer.dataset.wheelShareSuccess);
        } catch (error) {
          announce(customizer.dataset.wheelShareFailed);
        }
      });

      updateZoom(1);
      updateCompareSplit(50);
      let savedState = {};
      try { savedState = JSON.parse(window.localStorage.getItem('wheelBuilder44Tints') || '{}'); } catch (error) { savedState = {}; }
      const queryState = new URLSearchParams(window.location.search);
      const restoredState = {
        rim: queryState.get('rim') || savedState.rim,
        spoke: queryState.get('spoke') || savedState.spoke,
        hub: queryState.get('hub') || savedState.hub,
        fitment: queryState.get('fitment') || savedState.fitment
      };
      ['rim', 'spoke', 'hub'].forEach((part) => {
        const selection = selectionFromName(part, restoredState[part]);
        if (selection) applySelection(part, selection);
      });
      if (modelSelect && [...modelSelect.options].some((option) => option.value === restoredState.fitment)) modelSelect.value = restoredState.fitment;
      restoringState = false;
      syncCartForm();
      updateWheelStockStart();
      persistState();
    });

    const activateHomeReviews = (root) => {
      root.querySelectorAll('[data-home-review-showcase]').forEach((reviewSection) => {
        if (reviewSection.dataset.homeReviewsReady === 'true') return;
        reviewSection.dataset.homeReviewsReady = 'true';
        const toggle = reviewSection.querySelector('[data-home-review-toggle]');
        const more = reviewSection.querySelector('[data-home-review-more]');
        const label = reviewSection.querySelector('[data-home-review-toggle-label]');
        if (!toggle || !more) return;
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          more.hidden = !expanded;
          reviewSection.classList.toggle('is-expanded', expanded);
          if (label) label.textContent = expanded ? 'Show less' : 'View more';
        });
      });
    };
    activateHomeReviews(document);
    document.addEventListener('shopify:section:load', (event) => activateHomeReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verified-reviews-page-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.verified-review-page');
    if (!root) return;
    const cards = [...root.querySelectorAll('.verified-review-page__card')];
    const status = root.querySelector('[data-review-filter-status]');
    const ratingPicker = root.querySelector('[data-rating-picker]');
    const ratingLabel = root.querySelector('[data-rating-picker-label]');
    const ratingStars = [...root.querySelectorAll('.verified-review-page__rating-stars [data-review-value]')];
    const state = { bike: 'all', type: 'all', rating: 'all' };

    const paintRating = (value, preview = false) => {
      const numericRating = Number(value) || 0;
      ratingStars.forEach((star) => {
        star.classList.toggle('is-filled', Number(star.dataset.reviewValue) <= numericRating);
      });
      if (!preview && ratingPicker) {
        ratingPicker.dataset.selectedRating = value;
        if (ratingLabel) ratingLabel.textContent = value === 'all' ? 'Choose a star to show that exact rating' : `Showing ${value}-star reviews`;
      }
    };

    const classify = (card) => {
      const href = (card.getAttribute('href') || '').toLowerCase();
      let type = 'accessories';
      if (href.includes('frameguard') || href.includes('frame-guard')) type = 'guards';
      else if (href.includes('supermoto') || href.includes('wheelset')) type = 'wheels';
      else if (href.includes('tint-baja') || href.includes('pink-tint') || href.includes('red-tint')) type = 'tints';
      else if (href.includes('battery-baja') || href.includes('baja-designs-s2-pro')) type = 'lights';
      else if (href.includes('titanium') || href.includes('bolt') || href.includes('devmoto')) type = 'titanium';

      let bikes = ['universal'];
      if (href.includes('pink-tint-baja-s2-sport') || href.includes('baja-s2-titanium-bolts-set-of-4')) bikes = ['lbx', 'talaria'];
      else if (href.includes('red-tint-baja-squadron')) bikes = ['ultrabee'];
      else if (href.includes('frameguards-lbx') || href.includes('surron-lbx') || href.includes('baja-designs-s2-pro') || href.includes('72v-chi-style-surron') || href.includes('eride-pro') || href.includes('preordereride')) bikes = ['lbx'];
      else if (href.includes('talaria') || href.includes('mx3-mx4') || href.includes('mx5')) bikes = ['talaria'];
      else if (href.includes('ultra-bee')) bikes = ['ultrabee'];
      return { type, bikes };
    };

    const applyFilters = () => {
      let visible = 0;
      cards.forEach((card) => {
        const meta = classify(card);
        const review = card.querySelector('[data-review-rating]');
        const rating = review ? review.dataset.reviewRating : '';
        const showBike = state.bike === 'all' || meta.bikes.includes(state.bike);
        const showType = state.type === 'all' || meta.type === state.type;
        const showRating = state.rating === 'all' || rating === state.rating;
        card.hidden = !(showBike && showType && showRating);
        if (!card.hidden) visible += 1;
      });
      if (status) {
        status.textContent = visible === 0 && state.rating !== 'all'
          ? `No ${state.rating}-star reviews match the selected bike and part filters`
          : `Showing ${visible} review${visible === 1 ? '' : 's'}`;
      }
    };

    root.querySelectorAll('[data-review-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const dimension = button.dataset.reviewFilter;
        state[dimension] = button.dataset.reviewValue;
        root.querySelectorAll(`[data-review-filter="${dimension}"]`).forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        if (dimension === 'rating') paintRating(state.rating);
        applyFilters();
      });
    });

    ratingStars.forEach((star) => {
      star.addEventListener('pointerenter', () => paintRating(star.dataset.reviewValue, true));
      star.addEventListener('focus', () => paintRating(star.dataset.reviewValue, true));
    });
    if (ratingPicker) {
      ratingPicker.addEventListener('pointerleave', () => paintRating(state.rating));
      ratingPicker.addEventListener('focusout', (event) => {
        if (!ratingPicker.contains(event.relatedTarget)) paintRating(state.rating);
      });
    }

    const params = new URLSearchParams(window.location.search);
    ['bike', 'type', 'rating'].forEach((dimension) => {
      const requested = params.get(dimension);
      const button = requested && root.querySelector(`[data-review-filter="${dimension}"][data-review-value="${CSS.escape(requested)}"]`);
      if (button) button.click();
    });
    paintRating(state.rating);
    applyFilters();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verified-reviews-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.verified-review-page');
    if (!root) return;
    const cards = [...root.querySelectorAll('.verified-review-page__card')];
    const status = root.querySelector('[data-review-filter-status]');
    const state = { bike: 'all', type: 'all', rating: 'all' };

    const classify = (card) => {
      const href = (card.getAttribute('href') || '').toLowerCase();
      let type = 'accessories';
      if (href.includes('frameguard') || href.includes('frame-guard')) type = 'guards';
      else if (href.includes('supermoto') || href.includes('wheelset')) type = 'wheels';
      else if (href.includes('tint-baja') || href.includes('pink-tint') || href.includes('red-tint')) type = 'tints';
      else if (href.includes('battery-baja') || href.includes('baja-designs-s2-pro')) type = 'lights';
      else if (href.includes('titanium') || href.includes('bolt') || href.includes('devmoto')) type = 'titanium';

      let bikes = ['universal'];
      if (href.includes('frameguards-lbx') || href.includes('surron-lbx') || href.includes('baja-designs-s2-pro') || href.includes('72v-chi-style-surron') || href.includes('eride-pro') || href.includes('preordereride')) bikes = ['lbx'];
      else if (href.includes('talaria') || href.includes('mx3-mx4') || href.includes('mx5')) bikes = ['talaria'];
      else if (href.includes('ultra-bee')) bikes = ['ultrabee'];
      return { type, bikes };
    };

    const applyFilters = () => {
      let visible = 0;
      cards.forEach((card) => {
        const meta = classify(card);
        const review = card.querySelector('[data-review-rating]');
        const rating = review ? review.dataset.reviewRating : '';
        const showBike = state.bike === 'all' || meta.bikes.includes(state.bike);
        const showType = state.type === 'all' || meta.type === state.type;
        const showRating = state.rating === 'all' || rating === state.rating;
        card.hidden = !(showBike && showType && showRating);
        if (!card.hidden) visible += 1;
      });
      if (status) status.textContent = `Showing ${visible} review${visible === 1 ? '' : 's'}`;
    };

    root.querySelectorAll('[data-review-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const dimension = button.dataset.reviewFilter;
        state[dimension] = button.dataset.reviewValue;
        root.querySelectorAll(`[data-review-filter="${dimension}"]`).forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        applyFilters();
      });
    });

    const params = new URLSearchParams(window.location.search);
    ['bike', 'type', 'rating'].forEach((dimension) => {
      const requested = params.get(dimension);
      const button = requested && root.querySelector(`[data-review-filter="${dimension}"][data-review-value="${CSS.escape(requested)}"]`);
      if (button) button.click();
    });
    applyFilters();
  })();

  } catch(e) { console.error(e); }
})();
})();
